export function convertTZ(date: Date, timeZone = 'UTC') {
  const utcDate = new Date(date);

  // Ottieni le componenti locali per il fuso orario specificato
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  });

  const parts = formatter.formatToParts(utcDate).reduce(
    (acc, part) => {
      if (part.type !== 'literal') {
        acc[part.type] = Number.parseInt(part.value, 10);
      }
      return acc;
    },
    {} as Record<string, number>
  );

  return new Date(
    Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    )
  );
}
